<section class="flex min-h-0 flex-1 flex-col overflow-hidden">
  @if (!classroomUrl()) {
    <div class="flex min-h-0 flex-1 flex-col gap-6 overflow-auto px-6 py-6">
      <div>
        <h1 class="text-2xl font-bold">{{ 'door.providerHeading' | transloco }}</h1>
        <p class="mt-2 text-sm text-[var(--mat-sys-on-surface-variant)]">
          {{ 'door.providerIntro' | transloco }}
        </p>
      </div>

      @if (loading()) {
        <p role="status">{{ 'door.loadingSchedule' | transloco }}</p>
      } @else if (appointment(); as current) {
        <section aria-labelledby="appointment-heading">
          <h2 id="appointment-heading" class="text-lg font-semibold">
            {{ current.title || ('door.untitledAppointment' | transloco) }}
          </h2>
          <p class="mt-1 text-sm">
            <time [attr.datetime]="current.start">{{ current.start }}</time>
            –
            <time [attr.datetime]="current.end">{{ current.end }}</time>
          </p>
          @if (!happeningNow()) {
            <p class="mt-2 text-sm">{{ 'door.notStarted' | transloco }}</p>
          }
          <h3 class="mt-4 font-semibold">{{ 'door.clientsHeading' | transloco }}</h3>
          <ul class="mt-1 list-disc pl-5">
            @for (client of current.clients; track client.uuid) {
              <li>{{ clientName(client) }}</li>
            }
          </ul>
        </section>
        @if (doorUnreachable()) {
          <p role="alert">{{ 'door.doorDown' | transloco }}</p>
        }
        <button
          type="button"
          class="w-fit rounded-full px-4 py-2 text-sm font-semibold hover:bg-[var(--mat-sys-on-surface)]/10"
          [disabled]="starting()"
          (click)="openClassroom()"
        >
          {{ 'door.openClassroom' | transloco }}
        </button>
      } @else {
        @if (!error()) {
          <p>{{ 'door.noAppointment' | transloco }}</p>
        }
        @if (doorUnreachable()) {
          <p role="alert">{{ 'door.doorDown' | transloco }}</p>
        }
        <div class="flex flex-wrap gap-3">
          <button
            type="button"
            class="w-fit rounded-full px-4 py-2 text-sm font-semibold hover:bg-[var(--mat-sys-on-surface)]/10 disabled:opacity-40"
            [disabled]="starting()"
            (click)="startMeeting('lessonspace')"
          >
            {{ 'door.startLessonspace' | transloco }}
          </button>
          @if (hilinkMeetings) {
            <button
              type="button"
              class="w-fit rounded-full px-4 py-2 text-sm font-semibold hover:bg-[var(--mat-sys-on-surface)]/10 disabled:opacity-40"
              [disabled]="starting()"
              (click)="startMeeting('hilink')"
            >
              {{ 'door.startHilink' | transloco }}
            </button>
          }
        </div>
      }

      @if (error(); as message) {
        <p role="alert">{{ message.startsWith('door.') ? (message | transloco) : message }}</p>
      }
    </div>
  } @else {
    <h1 class="sr-only">{{ 'door.providerHeading' | transloco }}</h1>
    @if (error(); as message) {
      <p class="px-6 py-3" role="alert">
        {{ message.startsWith('door.') ? (message | transloco) : message }}
      </p>
    }
  }

  @if (classroomUrl(); as url) {
    <div class="flex shrink-0 items-center px-4 py-2">
      <button
        type="button"
        class="w-fit rounded-full px-4 py-2 text-sm font-semibold hover:bg-[var(--mat-sys-on-surface)]/10"
        (click)="openOverlay($event)"
      >
        {{ 'door.openGif' | transloco }}
      </button>
    </div>
    <div class="relative flex min-h-0 flex-1">
      <app-classroom-frame class="min-h-0 min-w-0 flex-1" [url]="url" />
      @if (overlayOpen()) {
        <app-resource-overlay
          [src]="sampleGif"
          [title]="'door.overlayTitle' | transloco"
          [alt]="'door.overlayImage' | transloco"
          [closeLabel]="'door.closeOverlay' | transloco"
          (closed)="closeOverlay()"
        />
      }
    </div>
  }
</section>
